import { subCategorySchema } from "@/schema/free-assessment/SubCategory";
import { z } from "zod";

export const categorySchema = z.object({
  id: z.number(),
  content: z.string(),
  sub_categories: z.array(subCategorySchema),
});

export type Category = z.infer<typeof categorySchema>;
